<script lang="ts">
  import { cn } from '@/lib/utils';
  import type { Snippet } from 'svelte';
  
  let { class: className = '', children, ...restProps }: { class?: string; children?: Snippet; [key: string]: any } = $props();
</script>

<div
  class={cn(
    'rounded-3xl border border-border/60 bg-card text-card-foreground shadow-soft transition-all duration-300',
    className
  )}
  {...restProps}
>
  {#if children}{@render children()}{/if}
</div>